/* Monvara countdown (2026-09-07)
   <mv-countdown data-end="2026-09-08T23:59:59-07:00" data-hide="#some-selector">
   Ticks once a second. On expiry it hides itself (and the data-hide target).
   The end value carries an explicit UTC offset, so every visitor counts down to
   the same absolute moment regardless of their own device timezone.

   NOTE: connectedCallback fires while the parser is still inside this element,
   so its children do NOT exist yet. Fields are therefore resolved lazily on
   each tick until they are found - querying them up front silently yields null
   and the timer writes nowhere while still looking alive. */
(function () {
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

  class MvCountdownEl extends HTMLElement {
    connectedCallback() {
      this.endMs = Date.parse(this.dataset.end || '');
      if (isNaN(this.endMs)) {
        console.warn('[mv-countdown] unparseable data-end:', this.dataset.end);
        return;
      }
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    get fields() {
      if (!this._fields || !this._fields.s) {
        this._fields = {
          d: this.querySelector('[data-cd="d"]'),
          h: this.querySelector('[data-cd="h"]'),
          m: this.querySelector('[data-cd="m"]'),
          s: this.querySelector('[data-cd="s"]')
        };
      }
      return this._fields;
    }

    expire() {
      if (this.timer) clearInterval(this.timer);
      this.setAttribute('hidden', '');
      var hide = this.dataset.hide;
      if (hide) {
        var host = document.querySelector(hide);
        if (host) host.setAttribute('hidden', '');
      }
      // Swap the surrounding copy so the bar never advertises a finished sale.
      // Mirrors what Liquid already does on a fresh server render; this covers
      // the visitor who had the page open as the deadline passed.
      var swap = this.dataset.swap;
      if (swap && this.dataset.swapText) {
        var target = document.querySelector(swap);
        if (target) target.textContent = this.dataset.swapText;
      }
      this.dispatchEvent(new CustomEvent('mv-countdown:expired', { bubbles: true }));
    }

    tick() {
      var left = Math.floor((this.endMs - Date.now()) / 1000);
      if (left <= 0) { this.expire(); return; }
      var f = this.fields;
      if (!f.s) return; // children not parsed yet - try again next tick
      // No days field on the page means days roll up into total hours, so a
      // 2-day sale reads "37" rather than silently losing a day.
      if (f.d) {
        var d = Math.floor(left / 86400);
        f.d.textContent = this.dataset.padDays === 'false' ? String(d) : pad(d);
        f.h.textContent = pad(Math.floor((left % 86400) / 3600));
      } else if (f.h) {
        f.h.textContent = pad(Math.floor(left / 3600));
      }
      if (f.m) f.m.textContent = pad(Math.floor((left % 3600) / 60));
      f.s.textContent = pad(left % 60);
      this.removeAttribute('hidden');
      // Fail OPEN: if Liquid could not parse the end date it renders the host
      // hidden, and only a live tick can prove the sale is still running.
      var host = this.dataset.hide && document.querySelector(this.dataset.hide);
      if (host) host.removeAttribute('hidden');
    }
  }

  if (!customElements.get('mv-countdown')) {
    customElements.define('mv-countdown', MvCountdownEl);
  }
})();
